////////////////////////////////////////////////////////////////////////////////////////////
// Google Maps
////////////////////////////////////////////////////////////////////////////////////////////
(function($) {

  /*global google*/

  /*
  *  new_map
  *
  *  This function will render a Google Map onto the selected jQuery element
  *
  *  @type	function
  *  @date	8/11/2013
  *  @since	4.3.0
  *
  *  @param	$el (jQuery element)
  *  @return	n/a
  */

  function new_map( $el ) {

    // var
    var $markers = $el.find('.marker');

    // vars
    var args = {
      zoom		               : 14,
      mapTypeId	             : google.maps.MapTypeId.ROADMAP,
      scrollwheel            : false,
      disableDefaultUI       : true,
      zoomControl            : true,
      styles: [
          {
            'elementType': 'labels',
            'stylers': [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'administrative',
            'stylers': [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'landscape',
            'stylers': [
              {
                'color': '#e5e8e7',
              },
              {
                'visibility': 'simplified',
              },
            ],
          },
          {
            'featureType': 'landscape.man_made',
            'stylers': [
              {
                'color': '#f5f5f2',
              },
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'landscape.natural',
            'stylers': [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'poi.attraction',
            'stylers': [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'poi.business',
            'stylers': [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'poi.government',
            'stylers': [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'poi.medical',
            'stylers': [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'poi.park',
            'stylers': [
              {
                'color': '#a1c58d',
              },
            ],
          },
          {
            'featureType': 'poi.place_of_worship',
            'stylers': [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'poi.school',
            'stylers': [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'poi.sports_complex',
            'stylers': [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'road',
            'stylers': [
              {
                'color': '#ffffff',
              },
              {
                'visibility': 'simplified',
              },
            ],
          },
          {
            'featureType': 'road',
            'elementType': 'labels',
            'stylers': [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'road.arterial',
            'stylers': [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'transit',
            'stylers': [
              {
                'visibility': 'off',
              },
            ],
          },
          {
            'featureType': 'water',
            'stylers': [
              {
                'color': '#3e71c5',
              },
            ],
          },
        ],
      };

    // create map
    var map = new google.maps.Map( $el[0], args);


    // add a markers reference
    map.markers = [];


    // add markers
    $markers.each(function(){

      add_marker( $(this), map );

    });

    // center map
    center_map( map );


    // return
    return map;

  }

  /*
  *  add_marker
  *
  *  This function will add a marker to the selected Google Map
  *
  *  @type	function
  *  @date	8/11/2013
  *  @since	4.3.0
  *
  *  @param	$marker (jQuery element)
  *  @param	map (Google Map object)
  *  @return	n/a
  */

  function add_marker( $marker, map ) {

    // var
    var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

    // custom icon
    var icon = {
      url: $marker.data('icon'),
      anchor: new google.maps.Point(0,0),
      scaledSize: new google.maps.Size(40,40),
    }

    // create marker
    var marker = new google.maps.Marker({
      position	: latlng,
      map			  : map,
      icon      : icon,
    });

    // add to array
    map.markers.push( marker );

    // if marker contains HTML, add it to an infoWindow
    if( $marker.html() )
    {
      // create info window
      var infowindow = new google.maps.InfoWindow({
        content		: $marker.html(),
      });

      // show info window when marker is clicked
      google.maps.event.addListener(marker, 'click', function() {

        infowindow.open( map, marker );

      });
    }

  }

  /*
  *  center_map
  *
  *  This function will center the map, showing all markers attached to this map
  *
  *  @type	function
  *  @date	8/11/2013
  *  @since	4.3.0
  *
  *  @param	map (Google Map object)
  *  @return	n/a
  */

  function center_map( map ) {

    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each( map.markers, function( i, marker ){

      var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

      bounds.extend( latlng );

    });

    // only 1 marker?
    if( map.markers.length === 1 ) {
      // set center of map
      map.setCenter( bounds.getCenter() );
    } else {

      // fit to bounds
      map.fitBounds(bounds, {left:650});
    }
  }

  /*
  *  document ready
  *
  *  This function will render each map when the document is ready (page has loaded)
  *
  *  @type	function
  *  @date	8/11/2013
  *  @since	5.0.0
  *
  *  @param	n/a
  *  @return	n/a
  */
  // global var
  var map = null; // eslint-disable-line no-unused-vars

  $(document).ready(function(){
    map = new_map( $('.map') );

    google.maps.event.addDomListener(window, 'resize', function() {
      center_map(map);
    });
  });

})(jQuery);
